var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-traclytable',{attrs:{"theader":_vm.theader,"checkbox":_vm.checkbox,"numbers":_vm.numbers,"items":_vm.items}})}
var staticRenderFns = []

export { render, staticRenderFns }